import { motion } from "framer-motion";
import { Check } from "lucide-react";

const POINTS = [
  "Grade-2 verified, EN-certified equipment",
  "Wireless & hybrid systems, zero mess",
  "Smart-home & app control out of the box",
  "Domestic and commercial approved",
];

export const Partner = () => {
  return (
    <section
      id="partner"
      data-testid="partner"
      className="relative overflow-hidden py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="relative grid gap-10 overflow-hidden border border-cyanbrand/20 bg-gradient-to-br from-[#0c0c0c] to-[#050505] p-8 md:grid-cols-2 md:p-14"
        >
          <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-cyanbrand/10 blur-3xl" />

          <div className="relative z-10">
            <span className="font-mono text-xs uppercase tracking-[0.2em] text-cyanbrand">
              / In collaboration with
            </span>
            <h2 className="mt-5 font-display text-5xl md:text-7xl font-semibold tracking-tighter">
              Ajax
            </h2>
            <p className="font-display text-xl md:text-2xl font-medium tracking-tight text-white/80">
              Security Systems
            </p>
            <p className="mt-6 max-w-md font-body text-sm md:text-base text-white/55 leading-relaxed">
              SC Security is a proud partner and installer of Ajax — the
              award-winning European distributor of wireless security cameras and
              intruder systems for domestic and commercial use. It means you get
              best-in-class hardware, backed by local, certified engineers.
            </p>
          </div>

          <div className="relative z-10 flex flex-col justify-center gap-4">
            {POINTS.map((p, i) => (
              <motion.div
                key={p}
                initial={{ opacity: 0, x: 20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.1 + i * 0.08, duration: 0.5 }}
                data-testid={`partner-point-${i}`}
                className="flex items-center gap-4 border-b border-white/10 pb-4"
              >
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-cyanbrand/10 text-cyanbrand">
                  <Check className="h-4 w-4" />
                </span>
                <span className="font-body text-sm md:text-base text-white/80">{p}</span>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};
